import { Box } from '@mantine/core';
import clsx from 'clsx';
import { ReactNode } from 'react';

import classes from './FormControl.module.scss';
import { FormLabel } from '../FormLabel';

type FormControlProps = {
  children: ReactNode;
  title?: string | null;
  subTitle?: string | null;
  withAsterisk?: boolean;
  withSeparator?: boolean;
  className?: string;
};

export function FormControl(props: FormControlProps) {
  const { children, title, subTitle, withAsterisk = false, withSeparator = false, className } = props;

  return (
    <Box className={clsx(classes.propContainer, { [classes.withSeparator]: withSeparator }, className)}>
      <FormLabel title={title} subTitle={subTitle} withAsterisk={withAsterisk} />
      {children}
    </Box>
  );
}
